import { BarChartComponent, Props as BarChartComponentProps } from './BarChartComponent';

const BarChartComponentAngular = ({ data, labels, chartsScaleFactor }: BarChartComponentProps) => {
  return <BarChartComponent data={data} labels={labels} chartsScaleFactor={chartsScaleFactor} />;
};

export default {
  ReactComponent: BarChartComponentAngular,
  bindings: {
    data: '<',
    labels: '<',
    chartsScaleFactor: '<',
  },
};
